import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelStatisticsInterface, FunnelStatisticsSwrInterface } from 'modules/funnels/funnel/types/funnel-statistics-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function useFunnelStatistics(t0) {
  const $ = _c(7);
  const {
    filter,
    funnelId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ""}${filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== funnelId || $[3] !== user) {
    t2 = () => {
      if (user) {
        return [`${FUNNELS_API}/${funnelId}/stats?${filterApi}`, RequestModuleEnum.Funnels];
      }
      return null;
    };
    $[1] = filterApi;
    $[2] = funnelId;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: statistics
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[5] !== statistics) {
    t3 = {
      statistics
    };
    $[5] = statistics;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}